import { useEffect, useState } from "react";
import { StreamChat } from "stream-chat";
import { getInternalStreamChatClient } from "@/components/pages/chats/StreamChatClientManager";
import { useInternalChatToken } from "@/components/pages/chats/hooks/useInternalChatToken";

export const useInternalChatClient = (enabled = true) => {
  const [client, setClient] = useState<StreamChat | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { userChatData: chatData } = useInternalChatToken(enabled);

  useEffect(() => {
    let isMounted = true;

    const initClient = async () => {
      try {
        setIsLoading(true);

        if (!enabled) {
          setClient(null);
          setUserId(null);
          return;
        }

        if (!isMounted || !chatData?.token || !chatData?.chatUserId) {
          return;
        }

        const chatClient = await getInternalStreamChatClient(
          chatData.chatUserId,
          chatData.token,
        );

        if (isMounted) {
          setClient(chatClient);
          setUserId(chatData.chatUserId);
        }
      } catch (error) {
        console.error("Failed to initialize internal chat client:", error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initClient();

    return () => {
      isMounted = false;
    };
  }, [chatData, enabled]);

  return {
    client,
    userId,
    isLoading,
  };
};
